<script setup>
import { ref, computed, defineAsyncComponent } from 'vue'
import { useGlobalStore } from '@stores/global.js'
const global = useGlobalStore()

const modal = ref()
const loadModal = (name) => {
	return defineAsyncComponent(() => import(`@components/global/modals/${name}.vue`))
}
const modalComponent = computed(() => loadModal(global.modal.name))
</script>

<template>
	<div class="fixed z-50 flex h-full w-full items-center justify-center">
		<div class="container relative z-50 mx-5 w-full overflow-y-auto rounded-md p-5" style="max-height: calc(100dvh - 2.5rem)">
			<transition name="fade" mode="out-in">
				<button class="absolute right-0 top-0 flex h-10 w-10 items-center justify-center rounded-full bg-snk-blue-500 text-white" @click="global.closeModal()" aria-label="Close Modal" aria-controls="modal" tabindex="0" v-if="global.modal.canClose">
					<i class="fas fa-xmark text-2xl" />
				</button>
			</transition>
			<component :is="modalComponent" ref="modal" />
		</div>
		<div class="absolute left-0 top-0 h-full w-full bg-black/80 backdrop-blur-sm" @click="global.closeModal()"></div>
	</div>
</template>
